export default "__VITE_ASSET__nSwIQAjw__"